// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.hero-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.hero-subtitle {
  opacity: 0.9;
  font-size: 1rem;
}

.hero-price {
  font-size: 1.5rem;
  font-weight: 600;
}

.status-badge {
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
}

.status-badge.active {
  background-color: rgba(16, 185, 129, 0.2);
  color: #059669;
}

.status-badge.inactive {
  background-color: rgba(107, 114, 128, 0.2);
  color: #6b7280;
}

.metric-card {
  height: 100%;
  transition: all 0.3s ease;
  border: 1px solid #e5e7eb;
}

.metric-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
}

.metric-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.metric-value {
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1;
}

.metric-subtitle {
  font-size: 0.75rem;
  color: #6b7280;
  margin-top: 2px;
}

.metric-title {
  font-size: 0.875rem;
  color: #374151;
  font-weight: 500;
}

.financial-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.financial-card {
  padding: 1rem;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
}

.financial-card:hover {
  background: #f1f5f9;
  transform: translateY(-2px);
}

.financial-label {
  font-size: 0.875rem;
  color: #64748b;
  margin-bottom: 4px;
}

.financial-value {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 4px;
}

.financial-trend {
  font-size: 0.75rem;
  font-weight: 500;
}

.financial-trend.positive {
  color: #059669;
}

.financial-trend.negative {
  color: #dc2626;
}

.financial-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  flex-shrink: 0;
}

.info-section {
  height: 100%;
}

.section-subtitle {
  color: #374151;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.area-breakdown .area-item {
  margin-bottom: 1rem;
}

.timeline-container {
  position: relative;
}

.timeline-item {
  display: flex;
  margin-bottom: 1.5rem;
  cursor: pointer;
}

.timeline-marker {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.25rem;
  flex-shrink: 0;
}

.timeline-content {
  margin-left: 1rem;
  flex: 1 1;
}

.timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.timeline-title {
  font-weight: 600;
  color: #374151;
}

.timeline-date {
  font-size: 0.875rem;
  color: #6b7280;
}

.timeline-details {
  margin-top: 0.75rem;
}

.action-btn {
  padding: 12px 20px;
  border-radius: 10px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.section-header-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.5rem;
  flex-shrink: 0;
}

.card-hover:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.custom-table th, .custom-table td {
  padding: 0.75rem 0;
  border-color: #f1f5f9;
  font-size: 0.875rem;
}

.custom-table th {
  font-weight: 500;
  color: #374151;
}

.custom-table tr:last-child th, 
.custom-table tr:last-child td {
  border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/Tabels/Block/css/BlockDetail.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB","sourcesContent":[".hero-card {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.hero-title {\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n}\n\n.hero-subtitle {\n  opacity: 0.9;\n  font-size: 1rem;\n}\n\n.hero-price {\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.status-badge {\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n}\n\n.status-badge.active {\n  background-color: rgba(16, 185, 129, 0.2);\n  color: #059669;\n}\n\n.status-badge.inactive {\n  background-color: rgba(107, 114, 128, 0.2);\n  color: #6b7280;\n}\n\n.metric-card {\n  height: 100%;\n  transition: all 0.3s ease;\n  border: 1px solid #e5e7eb;\n}\n\n.metric-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 10px 25px rgba(0,0,0,0.1);\n}\n\n.metric-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.metric-value {\n  font-size: 1.75rem;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.metric-subtitle {\n  font-size: 0.75rem;\n  color: #6b7280;\n  margin-top: 2px;\n}\n\n.metric-title {\n  font-size: 0.875rem;\n  color: #374151;\n  font-weight: 500;\n}\n\n.financial-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.financial-card {\n  padding: 1rem;\n  background: #f8fafc;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  transition: all 0.3s ease;\n}\n\n.financial-card:hover {\n  background: #f1f5f9;\n  transform: translateY(-2px);\n}\n\n.financial-label {\n  font-size: 0.875rem;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.financial-value {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.financial-trend {\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.financial-trend.positive {\n  color: #059669;\n}\n\n.financial-trend.negative {\n  color: #dc2626;\n}\n\n.financial-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.25rem;\n  flex-shrink: 0;\n}\n\n.info-section {\n  height: 100%;\n}\n\n.section-subtitle {\n  color: #374151;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n}\n\n.area-breakdown .area-item {\n  margin-bottom: 1rem;\n}\n\n.timeline-container {\n  position: relative;\n}\n\n.timeline-item {\n  display: flex;\n  margin-bottom: 1.5rem;\n  cursor: pointer;\n}\n\n.timeline-marker {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 1.25rem;\n  flex-shrink: 0;\n}\n\n.timeline-content {\n  margin-left: 1rem;\n  flex: 1;\n}\n\n.timeline-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n\n.timeline-title {\n  font-weight: 600;\n  color: #374151;\n}\n\n.timeline-date {\n  font-size: 0.875rem;\n  color: #6b7280;\n}\n\n.timeline-details {\n  margin-top: 0.75rem;\n}\n\n.action-btn {\n  padding: 12px 20px;\n  border-radius: 10px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.section-header-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 0.5rem;\n  flex-shrink: 0;\n}\n\n.card-hover:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 30px rgba(0,0,0,0.1);\n}\n\n.custom-table th, .custom-table td {\n  padding: 0.75rem 0;\n  border-color: #f1f5f9;\n  font-size: 0.875rem;\n}\n\n.custom-table th {\n  font-weight: 500;\n  color: #374151;\n}\n\n.custom-table tr:last-child th, \n.custom-table tr:last-child td {\n  border-bottom: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
